import Common from './common';
import UserAPI from './api/user';
import MunicipalityAPI from "./api/docMunicipality";

export default {
    constants: {
        LOCAL_STORAGE_MUNICIPALITY_ID: "municipalityId",

        SECTION_TYPES: {
            NEWS: '1eb9efe2-1428-476a-a69c-46c1cebb9dab',
            DOCUMENTS: '1eb9efe2-1428-476a-a69c-46c1cebb9dac',
        },

        APPEAL_STATUS: {
            PROCESS: 'd3b9fddf-8989-47f6-9242-05d646b16da5',
            WAIT_USER_ACTION: 'cbdcb7e1-1b03-4931-b066-f749719c79fd',
            DENY: '524183ef-6212-4faa-9b8e-41f371147512',
            SENT: 'c48f8498-053e-4930-a8f9-f6937b4e7ac6',
            RECEIVED: '857c0e43-c5e1-4e1a-8cda-e22277392c9a',
            STOP: '72f0ac01-c990-4632-b6e5-5ca0b42bb3ea'
        },
        STORE_MODES: {
            SERVER: '54480ce1-00eb-4179-a2b6-f74daa6b9e71',
            EXTERNAL_LINK: '54480ce1-00eb-4179-a2b6-f74daa6b9e72',
        },
        MUNICIPALITIES: {
            ALL: '1a4cb6dd-fb47-4838-bbcf-81518e7fc7aa'
        },
    },
    props: {
        "appName": "SCY",
        "authorizedUser": null,
        "allowSelectStyle": false,
        "currentPage": null,
        "onlyAuthorized": null,
        'menuCollapsed': false,
        "municipalityId": null,
        "municipalities": null,
        "municipalities_dictionary": null,
    },

    getCurrentMunicipality: function() {
        return Application.props.municipalities_dictionary[localStorage.getItem("municipalityId")];
    },

    setCurrentMunicipalityName: function() {
        var name = this.getCurrentMunicipality().name;
        $("#municipality_name_span").text(name);
    },

    onSuccessLogin: function () {
        UserAPI.logged(Application.onSuccessLogged, Application.onFailLogged);
    },
    onFailLogin: function () {
        Common.showToast('error', 'Ошибка', 'Неверный логин или пароль');
    },
    onSuccessLogged: function (authorizedUser) {
        Application.props.authorizedUser = authorizedUser;
    },
    onFailLogged: function () {
        if (Application.props.onlyAuthorized != null && Application.props.onlyAuthorized == true) {
            Common.goToUrl("/login");
        }
    },
    onCompleteLogout: function () {
        Application.props.authorizedUser = null;
        Common.goToUrl("/");
    },
    onPageLoad: function () {
        UserAPI.logged(Application.onSuccessLogged, Application.onFailLogged);
        this.props.municipalities = MunicipalityAPI.municipalities(this.props.currentPage, null, false, 0, 1, 10000, "el.name", "ASC", null, null).data;

        this.props.municipalityId = localStorage.getItem(this.constants.LOCAL_STORAGE_MUNICIPALITY_ID);
        if (!this.props.municipalityId) {
            localStorage.setItem(this.constants.LOCAL_STORAGE_MUNICIPALITY_ID, this.props.municipalities[0].id);
        }

        this.props.municipalityId = localStorage.getItem(this.constants.LOCAL_STORAGE_MUNICIPALITY_ID);

        this.props.municipalities_dictionary = [];
        for (let i = 0; i < this.props.municipalities.length; i++) {
            let item = this.props.municipalities[i];
            this.props.municipalities_dictionary[item.id] = item;
        }

        let that = this;
        setTimeout(function() {
            that.setCurrentMunicipalityName();
        }, 50);
    },
    process: function (currentPage, onlyAuthorized) {
        Application.props.currentPage = currentPage;
        Application.props.onlyAuthorized = onlyAuthorized;
        Application.onPageLoad();
    },
    getBasePath: function () {
        return window.location.origin + '/scy-core-web';
    },
};



// WEBPACK FOOTER //
// ./src/application.js